<!--
 * @Date: 2022-07-19 14:42:45
 * @LastEditTime: 2022-07-19 14:43:12
 * @FilePath: /vue-medweb/packages/vue-m-vaccine-prefecture/src/components/Loading/index.vue
 * @Description: loading组件
-->
<template>
  <div class="loading-box">
    <van-loading color="#39d167" />
  </div>
</template>

<script>
export default {
  name: 'Loading',
};
</script>

<style lang="scss">
.loading-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}
</style>
